import _throttle from "lodash/throttle";

type PropertyChangeMap = {
  [pathToProperty: string]: (args: any) => void;
};

const throttledPropertyChangeFunctions: {
  elements: PropertyChangeMap;
  globalSettings: PropertyChangeMap;
  selectorSettings: PropertyChangeMap;
  variableSettings: PropertyChangeMap;
  presetSettings: PropertyChangeMap;
} = {
  elements: {},
  globalSettings: {},
  selectorSettings: {},
  variableSettings: {},
  presetSettings: {}
};

// This could be a generic function that throttles by key but I made it more specific on purpose
export function throttlePropertyChange<T>(
  path: string,
  propertyChangeCallback: (args: T) => void,
  propertyChangeArgs: T,
  propertyChangeName:
    | "elements"
    | "globalSettings"
    | "selectorSettings"
    | "variableSettings"
    | "presetSettings"
): void {
  if (!throttledPropertyChangeFunctions[propertyChangeName][path]) {
    /*
    throttle wait is based on performance metrics taken on 26/03/2020 on a Macbook pro 2019
    where a property change re-render takes about 60ms.

    If performance improves, it could be decreased for higher FPS
    As long as the wait is below 100ms, the perceived performance is good
    https://www.pubnub.com/blog/how-fast-is-realtime-human-perception-and-technology/
    */

    throttledPropertyChangeFunctions[propertyChangeName][path] = _throttle(
      propertyChangeCallback,
      80
    );
  }

  const throttledFunction =
    throttledPropertyChangeFunctions[propertyChangeName][path];

  if (throttledFunction) {
    throttledFunction(propertyChangeArgs);
  }
}
